import { styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

const buttonBarHeight = '67px';

export const ButtonBarHolder = styled.div`
  min-height: ${buttonBarHeight};
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 3;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }

  @media print {
    display: none;
  }
`;

export const InnerButtonBarHolder = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  min-height: ${buttonBarHeight};
  background-color: ${colors.white};
  box-shadow: 0 -3px 4px 1px rgb(0 0 0 / 0.15);

  & > button,
  & > a {
    &:first-child {
      margin-left: 16px;
    }

    margin-right: 16px;
  }
`;
